import type { SVGProps } from "react";
export interface CherriesIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function CherriesIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: CherriesIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M14.404 1.884c.092-.008.186-.01.281.006.093.015.18.047.262.083a1.1 1.1 0 0 1 .46.363q.014.02.027.041.019.028.036.056.014.028.028.057a1 1 0 0 1 .075.186 1 1 0 0 1 .042.226c.008.092.01.187-.006.282l-.077.518c-.345 2.542-.004 4.446.486 5.888.264.778.579 1.437.875 2.017.204.402.44.834.622 1.225l.161.373.037.11a1.125 1.125 0 0 1-2.086.812l-.047-.106-.116-.263c-.133-.282-.321-.627-.577-1.128a17 17 0 0 1-.999-2.316c-.451-1.329-.78-2.948-.741-4.925-1.544 1.418-2.508 3.105-3.108 4.606a15 15 0 0 0-.774 2.6 12 12 0 0 0-.155 1.01v.006a1.126 1.126 0 0 1-2.244-.164v-.004l.001-.008q0-.009.002-.023l.007-.075a14 14 0 0 1 .182-1.18c.152-.767.42-1.823.89-2.997.938-2.345 2.701-5.216 5.984-7.131a1.1 1.1 0 0 1 .36-.13 1 1 0 0 1 .112-.015"
      />
      <path
        fill={color}
        d="M2.293 11.92c.87-.847 2.052-1.22 3.25-.969 1.008.21 1.571.866 1.902 1.229.358.394.485.496.7.54.217.046.378.002.869-.215.45-.198 1.232-.57 2.238-.36 1.199.25 2.132 1.067 2.58 2.196.442 1.116.385 2.459-.176 3.817-.53 1.281-1.418 2.442-2.709 3.177-1.302.741-2.913.991-4.772.618l-.02-.002c-1.852-.404-3.224-1.28-4.111-2.483-.88-1.193-1.21-2.614-1.165-3.998.05-1.468.554-2.713 1.414-3.55m16.163-.969c1.198-.25 2.381.122 3.25.968.861.838 1.365 2.083 1.414 3.551.046 1.384-.285 2.805-1.164 3.998-.887 1.203-2.26 2.079-4.112 2.483l-.02.002a8 8 0 0 1-2.248.147l-.299-.03-.112-.021a1.125 1.125 0 0 1 .285-2.221l.114.009.408.034c.42.016.887-.02 1.406-.124 1.395-.306 2.254-.917 2.767-1.614.523-.709.76-1.606.727-2.588-.034-1.006-.368-1.658-.734-2.014-.358-.348-.788-.467-1.22-.377-.174.037-.303.118-.538.366-.19.2-.62.736-1.184 1.065l-.102.053a1.126 1.126 0 0 1-1.033-1.995l.136-.097c.129-.108.255-.264.551-.575.349-.368.867-.844 1.708-1.02M5.083 13.154c-.432-.09-.864.029-1.221.377-.366.356-.7 1.008-.734 2.014-.033.982.204 1.879.726 2.588.513.696 1.371 1.307 2.763 1.614l.51.084c1.154.142 2.038-.07 2.707-.451.776-.442 1.366-1.17 1.743-2.082l.125-.341c.248-.771.2-1.38.038-1.787-.158-.397-.436-.66-.793-.78l-.156-.042c-.218-.045-.378-.001-.87.215-.45.199-1.232.57-2.237.36-1.008-.212-1.571-.866-1.902-1.228-.358-.394-.484-.496-.699-.54Z"
      />
    </svg>
  );
}
